'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/cart/cart'));
    // processInclude(require('./product/quickview'));
    require('./cart/cart').init();
});
